/**
 * 키보드 입력할 때 \u0010 형태의 DLE(Data Link Escape) 문자열을 제거한다.
 * DLE는 Control과 Space키로 발생되고, 운영 체제 또는 키보드 설정에서 단축키를 변경했을때 발생함
 * 예제 문자: "테스트"
 *
 * @see https://github.com/marpple/ciety-fe/blob/9277a9508f69cf85f130a62ddef71abc5486bda4/src/_utils/calibrator/removeDLE.ts#L1-L9
 */
export const removeDLE = (str: string) => {
  // eslint-disable-next-line no-control-regex
  return str.replace(/[\x08\x10]/g, '');
};
